
import { printHumanFloat, printHumanFloatDashboard } from "@/utils/pretty-print";
import Vue from "vue";
import {BookYearService, ChartService} from "@/services";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { DashboardRevenuePerMonthCompareData } from "@/utils/dashboard/dashboard-revenue-per-month-compare-data";

export default Vue.extend({
	data(){
		return {
			revenues: [] as {BookYear:number, Revenue:number}[]
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		}
	},
	computed: {
		currentYear():number {
			let bookyear = this.chartData.getBookYearOverrideValue();
			if (!bookyear) {
				bookyear = BookYearService.selectedBookYear;
			}
			return bookyear;
		},
		chartData():DashboardRevenuePerMonthCompareData{
			return this.item.Data as DashboardRevenuePerMonthCompareData;
		},
		currentRevenue():number{
			let profit = this.revenues.find(r=>r.BookYear == this.currentYear);
			if (!profit) return 0;
			return profit.Revenue;
		},
		colWidth():number {
			if (this.item.width > 1) {
				return 12 / Math.min(this.item.width, this.revenues.length);
			}
			return 12;
		}
	},
	methods: {
		getProfitPercentage(revenue:number, bookyear:number):number{
			let prevYear = this.revenues.find(r=>r.BookYear == bookyear-1);
			if (!prevYear) return 0;
			if (prevYear.Revenue == 0 && revenue > 0) {
				return 100;
			}
			if (prevYear.Revenue == 0 && revenue < 0) {
				return -100;
			}
			return ((revenue - prevYear.Revenue) / revenue) * 100.0;
		},
		getProfitPercentageAsString(revenue:number, bookyear:number):string {
			let profitPercentage = this.getProfitPercentage(revenue, bookyear);
			if (profitPercentage > 0){
				return "+" + printHumanFloat(profitPercentage, 0);
			}
			return printHumanFloat(profitPercentage, 0);
		},
		printHumanFloat(n:number):string{
			return printHumanFloatDashboard(n);
		},
		async fetch(){
			let years = [];
			for (let i = this.currentYear; i > this.currentYear - this.chartData.ToShowYears; i--) {
				years.push(i);
			}
			this.revenues = await ChartService.getRevenueToday(years, this.chartData.filters);
		}
	},
	mounted(){
		this.fetch();
	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	}
});
